import { render, staticRenderFns } from "./editor-edit-exam.vue?vue&type=template&id=abedc98e&scoped=true&"
import script from "./editor-edit-exam.vue?vue&type=script&lang=js&"
export * from "./editor-edit-exam.vue?vue&type=script&lang=js&"
import style0 from "./editor-edit-exam.vue?vue&type=style&index=0&id=abedc98e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abedc98e",
  null
  
)

export default component.exports